<template>
  <v-card outlined tile class="ma-3 pa-0 align-start">
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Компонент</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP.COMP_NAME" dense readonly >
          <template v-slot:append v-if="mode=='editor'">
            <v-icon small @click="callSelectRefComponent"> mdi-plus-circle-multiple-outline </v-icon>
          </template>
        </v-text-field>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Нижний предел</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_LOWER_LIMIT" dense type="number" :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Верхний предел</v-chip>
      </v-card>
      <v-card tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_UPPER_LIMIT" dense type="number" :readonly="mode=='viewer'"/>
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Цена</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_PRICE" dense type="number" :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <v-card tile class="d-flex justify-start">
      <v-card outlined tile class="pl-3 pr-3" width="250px">
        <v-chip class="ma-2" color="primary">Шаг</v-chip>
      </v-card>
      <v-card outlined tile class="pl-3 pr-3" width="400px">
        <v-text-field v-model="COMP_STEP" dense type="number" :readonly="mode=='viewer'" />
      </v-card>
    </v-card>
    <prj-select-ref-component-dialog :ref-component="COMP" v-model="showSelectRefComponent" @onRefComponentChanged="setRefComponent" />
  </v-card>
</template>

<script>
import PrjSelectRefComponentDialog from '@/components/modules/projects/dialogs/prjSelectRefComponentDialog'
export default {
  name: 'projectComponentCard',
  components: { PrjSelectRefComponentDialog },
  props: ['comp', 'mode'],
  data () {
    return {
      showSelectRefComponent: false
    }
  },
  computed: {
    COMP_LOWER_LIMIT: {
      get () {
        return this.comp ? this.comp.COMP_LOWER_LIMIT : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_LOWER_LIMIT: val })
      }
    },
    COMP_UPPER_LIMIT: {
      get: function () {
        return this.comp ? this.comp.COMP_UPPER_LIMIT : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_UPPER_LIMIT: val })
      }
    },
    COMP_STEP: {
      get: function () {
        return this.comp ? this.comp.COMP_STEP : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_STEP: val })
      }
    },
    COMP_PRICE: {
      get: function () {
        return this.comp ? this.comp.COMP_PRICE : ''
      },
      set (val) {
        this.$emit('onCompUpdate', { COMP_PRICE: val })
      }
    },
    COMP: {
      get: function () {
        console.log('getting COMP as ', this.comp)
        return this.comp ? { COMP_ID: this.comp.COMP_ID, COMP_NAME: this.comp.COMP_NAME, COMP_CODE: this.comp.COMP_CODE } : { }
      },
      set (val) {
        console.log('setting COMP as ', val)
        this.$emit('onCompUpdate', val ? { COMP_ID: val.COMP_ID, COMP_NAME: val.COMP_NAME, COMP_CODE: val.COMP_CODE } : {})
      }
    }
  },
  methods: {
    callSelectRefComponent () {
      this.showSelectRefComponent = true
    },
    setRefComponent (val) {
      console.log('projectComponentCard setting Reference component to ', val)
      this.COMP = val
    }
  },
  mounted () {
    console.log('projectComponentCard mounted in mode ', this.mode, ' with Component ', this.comp)
  }
}
</script>
